/**
 * 묶음 Y(DESIGN 14.429, 평론 G5) — **세계가 끝났을 때의 결산 카드.**
 *
 * 세계가 끝나면 소켓을 끊고 캐릭터 선택 화면으로 보낸다. 전에는 그 사실을 오류 칸(`#err`, 붉은 글·role=alert)에
 * 한 문장으로 적었다 — 사람 눈에는 「튕겼다」였고, 이번 세계에서 이룬 것·다음 세계로 가져가는 것·새 세계로 들어가는 법이
 * 한 장면에 없었다. 이 카드는 선택 화면 맨 위에 그 셋을 모으고, 「새 세계로 들어가기」 한 번이면 같은 캐릭터로 들어간다.
 *
 *   · 이룬 것은 **끊기기 직전 서버가 준 몸**(`you.level`·`you.kills`·`you.name`)에서 뽑는다 — 새로 계산하지 않는다.
 *   · 가져가는 것은 창고 창과 같은 함수(`carryHtml` — 서버 `you.carry`)다. 남는 것·사라지는 것은 도움말 「세계가 끝나면」 표가 정본이다.
 *   · 판정·보상은 없다. 버튼은 최신 캐릭터 목록의 직업 선택·입장으로 안내한다.
 */
import { $, esc } from '../core/state.js';
import { carryHtml, vaultWipeState } from './world-end-notice.js';

let recap = null;

/** 끊기기 직전의 몸에서 결산 자료를 뽑는다. 몸이 없으면(선택 화면에서 받은 알림) 세계 번호만 */
export function captureWorldRecap(y, oldWorld, charId) {
  const n = Number(oldWorld) || 0;
  let carry = '';
  try { carry = y ? carryHtml(y) : ''; } catch { carry = ''; }
  return {
    n,
    charId: charId || null,
    name: y?.name ? String(y.name) : '',
    level: Number.isFinite(y?.level) ? Math.floor(y.level) : null,
    kills: Number.isFinite(y?.kills) ? Math.floor(y.kills) : null,
    carry,
    wipeVault: vaultWipeState(y),
  };
}

function box() {
  let el = $('#world-recap');
  if (el) return el;
  const play = document.querySelector('.start-play');
  if (!play) return null;
  el = document.createElement('div');
  el.id = 'world-recap';
  el.className = 'world-recap';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  play.insertBefore(el, play.firstChild);
  return el;
}

/** 종료 메시지에서 마지막으로 알던 규칙만 설명한다. 실제 창고 결과는 새 세계 입장 뒤 확인한다. */
export function worldRecapRules(r) {
  const vault = r?.wipeVault === true
    ? '마지막으로 확인한 설정에서는 창고의 은화·아이템·장비를 비우기로 돼 있었다'
    : r?.wipeVault === false
      ? '마지막으로 확인한 설정에서는 창고의 은화·아이템·장비를 남기기로 돼 있었다'
      : '창고 이월 설정은 확인되지 않았다';
  return `캐릭터는 이름 그대로 1레벨에서 다시 시작한다. ${vault}. 실제 창고 결과는 새 세계에 들어가 확인해 달라. 도감·집·길드는 남는다.`;
}

/** 카드를 그린다. `enter(charId)` = 최신 캐릭터 슬롯의 직업 선택으로 안내 */
export function showWorldRecap(r, enter) {
  recap = r;
  const el = box();
  if (!el || !r) return;
  const title = r.n > 0 ? `제 ${r.n} 세계가 끝났다` : '세계가 끝났다';
  const who = r.name && r.level !== null
    ? `<p class="wr-mine">이번 세계의 <b>${esc(r.name)}</b> — 마지막 <b>Lv${r.level}</b>${r.kills !== null ? ` · 처치 <b>${r.kills.toLocaleString('ko-KR')}</b>` : ''}</p>` : '';
  el.innerHTML = `<span class="ux-kicker">이번 여정의 마지막 기록</span><b class="wr-title">${title}</b>${who}`
    + '<p class="wr-rule">같은 이름으로 다음 세계에 다시 들어갈 수 있다.</p>'
    + (r.carry ? `<p class="wr-carry">${r.carry}</p>` : '')
    + `<p class="wr-rule">${r.wipeVault === true ? '마지막 확인 설정: 창고의 은화·아이템·장비를 비운다.' : r.wipeVault === false ? '마지막 확인 설정: 창고의 은화·아이템·장비를 남긴다.' : '창고 이월 설정은 확인되지 않았다.'}</p>`
    + '<details class="ux-details" id="world-recap-carry"><summary>새 출발과 보존 규칙</summary>'
    + `<p class="wr-rule">${esc(worldRecapRules(r))} 도움말 「세계가 끝나면」.</p></details>`
    + '<div class="wr-row">'
    + (r.charId && typeof enter === 'function' ? '<button type="button" class="gold" data-wr-enter="1">다음 세계에서 이어가기</button>' : '')
    + '<button type="button" class="ghost" data-wr-close="1">닫기</button></div>';
  el.hidden = false;
  el.querySelector('[data-wr-enter]')?.addEventListener('click', () => { const id = recap?.charId; if (id) enter(id); });
  el.querySelector('[data-wr-close]')?.addEventListener('click', hideWorldRecap);
  try { el.scrollIntoView({ block: 'nearest' }); } catch { /* 스크롤이 없는 곳 */ }
}

export function hideWorldRecap() {
  recap = null;
  const el = $('#world-recap');
  if (el) { el.hidden = true; el.innerHTML = ''; }
}
